import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Text from './Text';
import Image from './Image';

class Detail extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    getContent = (itemData, index) => {
        if (itemData.type === 'text') {
            return <Text content={itemData} key={index} />;
        } else if (itemData.type === 'image') {
            return <Image content={itemData} key={index} />;
        } else {
            return null;
        }
    };

    render() {
        const { content } = this.props;
        const { title, weMediaName, newsTime, contentList, weMediaLogo } = content;

        return (
            <article className={styles.article}>
                <h1 className={styles.title}>{title}</h1>
                <div className={styles.source}>
                    {weMediaLogo ? (
                        <div className={styles.avatar}>
                            <img src={weMediaLogo} />
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={styles.info}>
                        <div className={styles.author}>{weMediaName}</div>
                        <div className={styles.date}>{newsTime}</div>
                    </div>
                </div>
                <div className={styles.content}>{contentList.map((item, index) => this.getContent(item, index))}</div>
            </article>
        );
    }
}

export default errorBoundary(Detail);
